import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";
// export const getHandoverSummaryDetails = async (admissionId, userId) => {
//   return await templateMasterAbhijeetSir.get(
//     `/api/clinicalCareChart/isbarRetrieve/${admissionId}/${userId}`,
//   );
// };


export const saveNursesHandover = async (obj) => {
  return await apiClient?.post(
    `/isbarNursesHandover/saveOrUpdate`,
    obj, {
          headers: authHeader(),
        }
  );
};

export const acceptNursesHandoverSummary = async (id, acceptedBy, passcode) => {
  return await apiClient?.get(
    `/isbarNursesHandover/updateAccepted/${id}/${acceptedBy}/${passcode}`, {
          headers: authHeader(),
        }
  );
};

// export const getNureseHandoverFullData = async (admisssionId) => {
//   return await templateMasterAbhijeetSir.post(
//     `/api/isbarNursesHandover/getByAdmissionId/${admisssionId}`,
//   );
// };

export const getNureseHandoverFullData = async (Obj) => {
  return await apiClient.post(
    `/isbarNursesHandover/getByAdmissionId`,
    Obj, {
          headers: authHeader(),
        }
  );
};
export const getNursingHandoverEmp = async (Obj) => {
  return await apiClient?.post(
    `/isbarNursesHandover/dropdownEmployeeforNursingIsbarWeb`,
    Obj, {
          headers: authHeader(),
        }
  );
};

export const getNursingHandoverOldList = async (admissionId) => {
  return await apiClient?.get(
    `/isbarNursesHandover/getListNurseshandOver/${admissionId}`, {
          headers: authHeader(),
        }
  );
};

// /getIsbarHandoverList/{admissionId}